module.exports = __webpack_public_path__ + "static/media/troll_warlord.616b7131.png";